// PROD'da window.location.origin kullan; dev'de .env veya origin
export const ORIGIN_BASE = (
  process.env.NODE_ENV === 'production'
    ? window.location.origin
    : (process.env.REACT_APP_API_URL || window.location.origin)
).replace(/\/$/, '');

export const API_BASE    = `${ORIGIN_BASE}/api`;
export const UPLOAD_BASE = `${ORIGIN_BASE}/uploads`;
